import { useContext, useState, useRef, useEffect } from "react";
import { GlobalContext } from "../../context/Provider";
import Errormessage from "./errormessage";

export default (props: any) => {
    const {language_data, authState} = useContext(GlobalContext);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleSelect = (value: string) => {
        props.handleChange({ target: { name: props.name, value } });
        setIsOpen(false);
    };

    const selectedLabel = props.value 
        ? props.Array?.find((item: any) => item._id === props.value)?.name 
        : `${language_data?.[authState.lang]?.common_select} ${language_data?.[authState.lang]?.common_your} ${props.firstSelect}`;

    return <div className="form-select-box mb-3 position-relative" ref={dropdownRef}>
        <label htmlFor={props.id} className='fw-bolder mb-1'>{props.label}</label>
        <div 
            className={`form-select-custom shadow-none${props.error ? ' is-invalid' : ''}`}
            onClick={() => !props.disabled && setIsOpen(!isOpen)}
            style={{ cursor: props.disabled ? 'not-allowed' : 'pointer', backgroundColor: props.disabled ? '#e9ecef' : 'white' }}
        >
            <span style={{ color: 'inherit', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {selectedLabel}
            </span>
            <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'} ms-2`} aria-hidden="true"></i>
        </div>
        
        {isOpen && (
            <div className="custom-select-dropdown" style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                maxHeight: '200px',
                overflowY: 'auto',
                overflowX: 'hidden',
                backgroundColor: 'white',
                border: '1px solid #ddd',
                borderRadius: '4px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                zIndex: 1000
            }}>
                <div 
                    className="dropdown-option"
                    onClick={() => handleSelect('')}
                    style={{ padding: '8px 12px', cursor: 'pointer' }}
                >
                    {language_data?.[authState.lang]?.common_select} {language_data?.[authState.lang]?.common_your} {props.firstSelect}
                </div>
                {Array.isArray(props.Array) && props.Array.map((res: any, index: number) => (
                    <div 
                        key={index}
                        className={`dropdown-option${props.value === res._id ? ' active' : ''}`}
                        onClick={() => handleSelect(res._id)}
                        style={{ 
                            padding: '8px 12px', 
                            cursor: 'pointer',
                            backgroundColor: props.value === res._id ? '#007bff' : 'transparent',
                            color: props.value === res._id ? 'white' : 'inherit'
                        }}
                    >
                        {res?.name}
                    </div>
                ))}
            </div>
        )}
        
        {props.error && <Errormessage class={props.error} error={props.error} />}
    </div>
}